<template>
  <div v-if="popupVisible">
    <side-popup :title="title" width="400px" :popupVisible="popupVisible" @onClose="onClose">
      <div class="desc">{{ desc }}</div>
      <div slot="footer">
        <div @click="popupVisible = false" class="btn btn-cancle">取消</div>
        <div @click="onClose" class="btn">确认</div>
      </div>
    </side-popup>
  </div>
</template>

<script>
import SidePopup from "@/g-components/side-black-popup.vue";
// import SidePopup from "@/g-components/side-popup.vue";
import deepClone from "@/assets/js/deepClone.js";

export default {
  components: {
    SidePopup
  },
  props: {
    title: {
      type: String,
      default: '提示'
    }
  },
  data() {
    return {
      desc: '',
      popupVisible: false,
      tempData: {}
    }
  },
  created() {
    // this.toggle('Member')
  },
  methods: {
    onClose() {
      this.popupVisible = false
      this.$emit('onSubmit', this.tempData)
    },
    toggle(desc, tempData) {
      this.desc = desc
      this.tempData = deepClone(tempData)
      this.popupVisible = true
    }
  }
};
</script>

<style lang="less" scoped>
.desc {
  font-size: 18px;
  line-height: 26px;
  color: #fff;
  padding: 20px 0;
}
.btn {
  width: 150px;
  background-color: #ffc400;
  border: 0;
  color: #1a1c24;
  font-weight: 600;
  font-size: 16px;
  display: inline-block;
  line-height: 40px;
  border-radius: 4px;
  cursor: pointer;
  &.btn-cancle {
    background-color: #fff;
    // border: 1px solid #ffc400;
    margin-right: 15px;
  }
}
</style>
